function returnFalse() {
  return false;
}

function organizationsOnly(value) {
  return value.types.length === 1 && value.types[0] === 'Organization';
}

export default [
  {
    key: 'tags',
    label: 'Tags',
    moreFewerLabel: 'tags',
    isDisabled: returnFalse,
  },
  {
    key: 'states',
    label: 'State',
    moreFewerLabel: 'states',
    isDisabled: returnFalse,
  },
  {
    key: 'types',
    label: 'Recipient Type',
    moreFewerLabel: 'types',
    isDisabled: returnFalse,
  },
  {
    key: 'years',
    label: 'Election Year',
    moreFewerLabel: 'years',
    isDisabled: organizationsOnly,
  },
  {
    key: 'genders',
    label: 'Candidate Gender',
    moreFewerLabel: 'genders',
    isDisabled: organizationsOnly,
  },
  {
    key: 'affiliations',
    label: 'Political Affiliation',
    moreFewerLabel: 'affiliations',
    isDisabled: organizationsOnly,
  },
];
